import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type {
  Category,
  CreateUpdateCategoryRequest,
} from "../sharedTypes/categories"
import { BASE_CATEGORIES_QUERY_KEY } from "../queryKeys"

export const updateCategory = async (
  categoryId: string,
  params: CreateUpdateCategoryRequest
): Promise<Category> => {
  const response = await api.put<Category>(
    `/products/categories/${categoryId}/`,
    {
      body: params,
    }
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })

  return response.body
}
